import { useState } from "react";
import MembersSection from "../components/MembersSection";
import RolesPermissionsSection from "../components/RolesPermissionsSection";
import { HeadingText, Tabs } from "../../../shared/ui";

const tabItems = [
  { label: "Members", value: "members" },
  { label: "Roles & Permissions", value: "roles" },
];

const TeamManagementPage = () => {
  const [activeTab, setActiveTab] = useState("members");

  return (
    <section className="min-h-full bg-[#F3F4F8] md:p-6">
      <div className="rounded-[16px] bg-white p-4 md:p-6">
        <HeadingText className="text-[28px] font-[450] text-[#161827]">
          Team Management
        </HeadingText>

        <Tabs
          items={tabItems}
          value={activeTab}
          onChange={setActiveTab}
          className="my-4"
        />

        {activeTab === "roles" ? (
          <RolesPermissionsSection />
        ) : (
          <MembersSection />
        )}
      </div>
    </section>
  );
};

export default TeamManagementPage;
